import React from "react"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import { ExpandMoreRounded } from "@material-ui/icons"

import SEO from "../components/seo"
import Layout from "../components/layout"

const AboutPage = () => {
  return (
    <>
      <SEO title="О нас" />
      <Layout>
        <div className="about">
          <section>
            <h3> Добро пожаловать! </h3>
            «Наш Тюльпан» — это небольшая ферма, расположенная в
            живописном уголке Полесья, где с любовью выращивают тюльпаны вот
            уже {new Date().getFullYear() - 2016} лет. Наша семья занимается
            цветоводством, объединяя традиции и современный подход, чтобы каждый
            Наш Тюльпан радовал вас своей красотой и свежестью.
            <br />
            <br />
            <StaticImage
              src="../assets/images/nash_ciulpan.webp"
              alt="🌷"
              placeholder="blurred"
            />
            <br />
            <br />
            Выращивание тюльпанов — это не просто работа, а настоящее призвание.
            Мы тщательно отбираем сорта, заботимся о каждом этапе их роста и
            создаём идеальные условия, чтобы цветы росли здоровыми и крепкими.
            Начиная от заботливого отношения к почве, заканчивая бережной
            срезкой, упаковкой и доставкой.
            <br />
            <br />
            Мы гордимся тем, что выращиваем Наш Тюльпан с заботой об экологии и
            уважением к окружающей среде. Все цветы выращены с использованием
            натуральных удобрений, и при минимальном вмешательстве в
            естественные процессы, потому что для нас тюльпаны — это символ
            гармонии и возрождения природы.
            {/* <br />
            <br />
            Мы предлагаем свежие тюльпаны прямо из нашей теплицы, чтобы каждый
            мог насладиться их нежным ароматом и яркими красками. Будь то
            подарок для близких или украшение для дома — Наш Тюльпан приносит
            радость и весеннее настроение людям в самые важные для них моменты. */}
            <br />
            <br />
            Спасибо, что выбираете Наш Тюльпан! Мы будем рады разделить с вами
            любовь к цветам и подарить кусочек весны, который мы так бережно
            выращиваем своими руками. Присоединяйтесь к нашей цветочной семье и
            откройте для себя красоту тюльпанов из сердца Беларуси!
          </section>

          <section>
            <h3>Часто задаваемые вопросы:</h3>
            <div className="faq">
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                  Что входит в стоимость?
                </AccordionSummary>
                <AccordionDetails>
                  1. Цветок тюльпана
                  <br />
                  2. Упаковка в бумагу
                  <br />
                  3. Хранение на складе
                  <br />
                  4. Удобрение для предпродажной подготовки
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                  Как упакованы тюльпаны?
                </AccordionSummary>
                <AccordionDetails>
                  Тщательно отобранные по высоте и размеру тюльпаны в количестве
                  по 15 штук закручиваются в букеты из крафт-бумаги (входит в
                  стоимость). Эти букеты затем помещаются в прочные картонные
                  коробки (продаются отдельно) размером 60х40х60. В среднем в
                  коробку помещается около 255-270 цветков.
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                  Как осуществляется доставка?
                </AccordionSummary>
                <AccordionDetails>
                  Условия и стоимость доставки обговариваются индивидуально для
                  каждого клиента.
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                  Как хранить тюльпаны?
                </AccordionSummary>
                <AccordionDetails>
                  Приемлемыми условиями для хранения цветка тюльпана считается
                  тёмное помещение с температурой не менее 0 и не более +2
                  градусов Цельсия. В домашних условиях лучшим вариантом
                  является хранение в проветриваемом неотапливаемом помещении
                  вдали от солнца. При минусовых значениях температуры цветок
                  может "посинеть", а при воздействии солнечного света и/или
                  излишнего тепла — раскрыться.
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                  Как подготовить цветы к продаже?
                </AccordionSummary>
                <AccordionDetails>
                  Перед продажей цветы обязательно необходимо отпоить: для этого
                  их нужно поместить в раствор прохладной воды и специального
                  удобрения, которое мы предоставляем, предварительно обрезав
                  кончики стеблей для лучшего впитывания. Это удобрение не
                  только насыщает цветы влагой, но и продлевает их срок
                  хранения, сохраняя яркость и свежесть лепестков. После такой
                  процедуры тюльпаны будут выглядеть максимально привлекательно,
                  готовые радовать своих будущих обладателей.
                </AccordionDetails>
              </Accordion>
            </div>
          </section>
        </div>
      </Layout>
    </>
  )
}

export default AboutPage
